import { EuiComboBox, EuiComboBoxOptionOption, EuiFormLabel } from '@elastic/eui';
import { vehicleTypes } from 'cache';
import { VehicleType } from 'generated/graphql';
import { useLocalCache } from 'hooks/useLocalCache';
import { useIntl } from 'react-intl';

import * as S from './FiltersSidebar.styles';

export const VehicleTypeFilter = (): JSX.Element => {
  const { formatMessage } = useIntl();
  const localFilters = useLocalCache();

  return (
    <S.SidebarFilterWrapper>
      <EuiFormLabel>{formatMessage({ id: 'filters.vehicleTypes.label' })}</EuiFormLabel>
      <EuiComboBox
        placeholder={formatMessage({ id: 'filters.vehicleTypes.placeholder' })}
        options={
          Object.values(VehicleType)
            .filter((x) => !localFilters?.data?.vehicleTypes?.includes(x))
            .map((vehicle) => ({
              value: vehicle,
              label: formatMessage({ id: `filters.vehicleType.${vehicle}` }),
            })) ?? []
        }
        selectedOptions={localFilters?.data?.vehicleTypes?.map((vehicle) => ({
          label: formatMessage({ id: `filters.vehicleType.${vehicle}` }),
          value: vehicle,
        }))}
        onChange={(x: EuiComboBoxOptionOption<VehicleType>[]): VehicleType[] | undefined =>
          vehicleTypes(x?.map(({ value }) => value) as VehicleType[])
        }
      />
    </S.SidebarFilterWrapper>
  );
};
